import articles1 from "../files/img/static/art1.JPG";
import articles2 from "../files/img/static/art2.JPG";
import articles3 from "../files/img/static/art3.JPG";
import articles4 from "../files/img/static/art4.webp";
import articles5 from "../files/img/static/art5.webp";
import articles6 from "../files/img/static/art7.JPG";

export const articulos = [
  {
    id: 1,
    title: "Analgésicos para el dolor dental",
    textInfo:
      "El dolor de muelas es un síntoma de un problema en la cavidad oral. El origen del dolor dental puede depender de diferentes causas, siendo las más frecuentes las caries, la gingivitis, los abscesos dentales y la periodontitis.",
    text: "El dolor de muelas es un síntoma de un problema en la cavidad oral. El origen del dolor dental puede depender de diferentes causas, siendo las más frecuentes las caries, la gingivitis, los abscesos dentales y la periodontitis. Estas son condiciones graves que siempre requieren la intervención de un dentista para mantenerlas bajo control. El dolor de muelas es extremadamente molesto y difícil de soportar, pero puede aliviarse tomando medicamentos como los antiinflamatorios.",
    posted: "28 de enero de 2024",
    imgUrl: articles1,
  },
  {
    id: 2,
    title: "Cómo curar las aftas bucales",
    textInfo:
      `La estomatitis aftosa, comúnmente conocida como aftas bucales, es una afección muy molesta pero inofensiva de la cavidad oral.Son úlceras superficiales, de forma redonda u ovalada, con un centro blanco o amarillento y bordes rojizos. No son contagiosas y no deben confundirse con el herpes labial, que sí es causado por un virus. Aunque suelen desaparecer solas en 7 a 14 días. Mantén una buena higiene bucal, evita alimentos irritantes.

Es importante que vengas a consulta si:
- La afta dura más de 2 semanas
- Es muy dolorosa o impide comer/hablar
- Las aftas son recurrentes o múltiples 
- Notas fiebre, malestar general o ganglios inflamados`,
    text: "",
    posted: "1 de febrero de 2024",
    imgUrl: articles2,
  },
  {
    id: 3,
    title: "Miedo al dentista: cómo combatir la dentofobia",
    textInfo:
      `El miedo al dentista es la dentofobia, una enfermedad real reconocida por la Organización Mundial de la Salud. Lo primero que debes saber es que no estás solo. Como profesionales, estamos preparados para tratar no solo tus dientes, sino también tu ansiedad. Puedes contarnos cómo te sientes: estamos aquí para ayudarte, no para juzgarte.
      
Entiende que tu miedo es válido (y superable)
Acordaremos una señal para pausar
Platicaremos para conocer mejor sobre tus dudas y miedos
El ambiente lo adaptaremos a tu comodidad, con buena música, podcast o TV.
Practicaremos respiración profunda
Ven a una cita de evaluación sin compromiso`,
    text: "",
    posted: "5 de marzo de 2024",
    imgUrl: articles3,
  },
  {
    id: 5,
    title: "Importancia de Evitar la Automedicación",
    textInfo:
      "Descubre por qué es crucial evitar la automedicación y cómo nuestra clínica dental puede proporcionarte la orientación y el tratamiento adecuado para tu salud bucal. Confía en nuestros expertos para cuidar de ti de manera segura y efectiva.",
    text: "Esta nueva forma de Coronavirus (2019-nCoV, COVID-19) está alarmado a la población mundial. En Perú...",
    posted: "15 de mayo de 2024",
    imgUrl: articles4,
  },
  {
    id: 7,
    title: "Movilidad dental",
    textInfo:
      "La movilidad dentaria siempre es un problema para los pacientes que generalmente la relacionan con otras patologías como las enfermedades periodontales.",
    text: "Esta nueva forma de Coronavirus (2019-nCoV, COVID-19) está alarmado a la población mundial. En Perú...",
    posted: "15 de mayo de 2024",
    imgUrl: articles5,
  },
  {
    id: 8,
    title: "Caries dental",
    textInfo:
      `Es una lesión progresiva del diente causada por bacterias que se alimentan de los restos de alimentos (especialmente azúcares) y producen ácidos. 
      
En las primeras etapas, la caries no duele y puede pasar desapercibida.

Algunos signos de caries incluyen:
- Manchas blancas, marrones o negras en los dientes
- Sensibilidad al frío, calor o dulce
- Dolor leve o fuerte al masticar
- Mal aliento persistente
- Agujero visible en el diente (en etapas avanzadas)`,
    text: "Esta nueva forma de Coronavirus (2019-nCoV, COVID-19) está alarmado a la población mundial. En Perú...",
    posted: "15 de marzo de 2024",
    imgUrl: articles6,
  },
];
